import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_X629uKPekWOy: {
	id: 'prd_X629u2DEV2KPekWOy'
	ident: 'prd_X629uKPekWOy'
	sku: 'simple_premium_4w_11_99_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_BpajF2DEV2VRwJ0Q3'
			amount: 44
			amount_usd: 11.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 11.99
			discount: 32.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_O6IvZ2DEV2UEQq31d'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_X629uKPekWOy, SubscriptionProduct>
const prd_X629uKPekWOy = { ident: 'prd_X629uKPekWOy' } as typeof _prd_X629uKPekWOy

export default prd_X629uKPekWOy
